import React, { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SubChild({ currentValue, handleSelect }) {
  const [count, setCount] = useState(currentValue.number);
  let toastId1 = null;

  const handleDecrement = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };
  const showToast = () => {
    toast.info("Please unselect the option to increment/decrement the value.");
  };


  return (
    <div className="row border-bottom align-items-center px-2 exptraOptionMenu">
      <div className="col-6 exptraOptionMenuCentered">
        <div>
        <span className="child-text"> {currentValue?.type}</span>
        <span className="child-text"> {currentValue?.desc}</span>
        </div>
       
        <p className="child-price">{(currentValue?.price).toFixed(2)} &#8364; </p>
      </div>
      {/* <div className="col-3 d-flex justify-content-evenly align-items-center">
        <div>
          <span className="pt-2 uroo">{count}</span>
        </div>
        {currentValue.flag === "0" && <div>
         
          <span
            className="px-3 py-0 puls-minus-btn-darkblue pointer"
            onClick={handleDecrement}
          >
            -
          </span>
          <span
            className="px-3 py-0  puls-minus-btn-skyblue pointer"
            onClick={() => setCount(count + 1)}
          >
            +
          </span>
        </div>}
      </div> */}
      <div className="col-3 d-flex justify-content-evenly align-items-center plusMinus">
  <div>
    <span className="pt-2 uroo">{count}</span>
  </div>
  <div>
  <span
  className={`px-3 py-0 puls-minus-btn-darkblue pointer ${
    currentValue.flag !== "0" ? "disabled-button" : ""
  }`}
  onClick={
    currentValue.flag === "0" ? handleDecrement : showToast
  }
  style={currentValue.flag !== "0" ? { pointerEvents: "auto", opacity: 0.5 } : {}}
>
  -
</span>
<span
  className={`px-3 py-0 puls-minus-btn-skyblue pointer ${
    currentValue.flag !== "0" ? "disabled-button" : ""
  }`}
  onClick={
    currentValue.flag === "0" ? () => setCount(count + 1) : showToast
  }
  style={currentValue.flag !== "0" ? { pointerEvents: "auto", opacity: 0.5 } : {}}
>
  +
</span>
  </div>
</div>
      <div className="col-3 exptraOptionMenuCentered">
        {currentValue.flag === "1" ? (
          <Button
            variant="contained"
            className="py-2 px-3 exptraOptionButtonCentered"
            onClick={() => handleSelect(currentValue._id, 0, count)}
            style={{backgroundColor:"red", borderRadius: "5px", minWidth:"110px"}}
          >
            Unselect
            
          </Button>
        ) : (
          <button
            type="button"
            variant="contained"
            className="btn-select py-2 px-3 exptraOptionButtonCentered"
            onClick={() =>{
              if (count === 0) {
                if (!toast.isActive(toastId1)) {
                          toastId1 = toast.info(
                          "Please choose an amount to select.",
                          { autoClose: 2500 }
                          );
                        }
                return;
              }
              handleSelect(currentValue._id, 1, count)}}
          >
            Select
          </button>
        )}
      </div>
    </div>
  );
}
